import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { UtilsService } from '../../../services/utils.service';
import { ModalDialogService } from 'ngx-modal-dialog';
import { AlgProductsEnergyModalComponent } from '../../dialogs/alg-products-energy-modal/alg-products-energy-modal.component';
import { AlgGtmService } from '../../../services/alg-gtm.service';

@Component({
  selector: 'alg-header-button',
  templateUrl: './alg-header-button.component.html',
  styleUrls: ['./alg-header-button.component.scss'],
})
export class AlgHeaderButtonComponent implements OnInit {
  constructor(
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private gtm: AlgGtmService
  ) {}

  ngOnInit() {}

  openRecapModal() {
    this.gtm.submitOnbEvent('Vedi la tua offerta');
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: ``,
      childComponent: AlgProductsEnergyModalComponent,
      settings: {
        modalClass: 'modal fade ngx-modal product-card-modal',
        bodyClass: 'modal-body',
        modalDialogClass: 'modal-dialog',
        closeButtonClass: 'close theme-icon-close',
        contentClass: 'modal-content-product',
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/atoms/alg-header-button/alg-header-button.component.ts